import { QueryClient, useQuery } from '@tanstack/react-query'
import { OrgDocument } from '@vendia/control-plane-api'
import { useContext } from 'react'
import { useRecoilValue } from 'recoil'

import { authContext } from '../auth/auth-context'
import { selectedRoleState } from '../state'
import useControlPlaneApi from './use-control-plane-api'

const QUERY_KEY = 'getOrg'
const FIVE_MINUTES = 300000

export type GetOrg = NonNullable<ReturnType<typeof useGetOrg>['data']>['getOrganization']

export const useGetOrg = ({ ...options } = {}) => {
  const { auth } = useContext(authContext)
  const selectedRoleName = useRecoilValue(selectedRoleState).name

  const client = useControlPlaneApi()
  return useQuery({
    queryKey: [QUERY_KEY, selectedRoleName],
    queryFn: async () => {
      const data = await client.graphqlFetch({ query: OrgDocument })
      if (data.errors) {
        throw new Error(JSON.stringify(data.errors))
      }
      return data
    },
    staleTime: FIVE_MINUTES,
    enabled: auth.authenticated && !!selectedRoleName,
    ...options,
  })
}

export const refetchOrg = ({ queryClient }: { queryClient: QueryClient }) => {
  return queryClient.invalidateQueries({ queryKey: [QUERY_KEY], refetchType: 'all' })
}
